import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { jwtDecode } from "jwt-decode";
import { AuthContext } from "./context";

export default function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [logoutTimer, setLogoutTimer] = useState(null);

  const handleLogin = (token) => {
    try {
      const decoded = jwtDecode(token);
      localStorage.setItem("user", token); 
      setUser(decoded);

      const expiresInMs = decoded.exp * 1000 - Date.now();
      const timer = setTimeout(handleLogout, expiresInMs);
      setLogoutTimer(timer);
    } catch (err) {
      console.error("Invalid token during login:", err);
      handleLogout();
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("user");
    setUser(null);
    if (logoutTimer) clearTimeout(logoutTimer);
    window.location.href = "/";
  };

  useEffect(() => {
    const token = localStorage.getItem("user");
    if (!token) return;

    try {
      const decoded = jwtDecode(token);
      const now = Date.now() / 1000;

      if (decoded.exp && decoded.exp > now) {
        setUser(decoded);

        const expiresInMs = decoded.exp * 1000 - Date.now();
        const timer = setTimeout(handleLogout, expiresInMs);
        setLogoutTimer(timer);
      } else {
        handleLogout();
      }
    } catch (err) {
      console.error("Invalid token on app load:", err);
      handleLogout();
    }
  }, []);

  return (
    <AuthContext.Provider value={{ user, handleLogin, handleLogout }}>
      {children}
    </AuthContext.Provider>
  );
}

AuthProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
